import { Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DatePattern from "../PatternModal/DatePattern";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { lgDocPath } from "../../../constants/languageDocPaths";
import { api } from "../../../redux/api";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DefaultCheckbox from "./OutboundFieldFormattingOptions/DefaultCheckbox";
import NumberFormatter from "../PatternModal/NumberFormatter";

export const PatternControl = ({
  inputId, inputLabel, pattern, setPattern, noDateChooser, dpp, signed, setSigned, roundValue, setRoundValue, precision, setPrecision, bulkValuesHandler, sourceNodeInfo, selectedNode, disabled, ibDatePatternControl
}) => {
  // console.log(disabled, inputLabel);
  // Added bulkValuesHandler for sending values in bulk;
  // util
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // redux
  const queryParams = useSelector((state) => state.queryParams);

  // states
  const [valid, setValid] = useState(true);
  const [datePatternModal, setDatePatternModal] = useState(false);
  const [modalInput, setModalInput] = useState('');
  const [dpNetworkCallMessage, setDpNetworkCallMessage] = useState('');
  const [flag, setFlag] = useState(true);
  const [numberFormatterModal, setNumberFormatterModal] = useState(false);
  const [arg, setArg] = useState([]);

  // constants
  const docPath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/DateFormatter.html`;
  const numFormatterDocPath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/NumberFormatter.html`;

  // handle Ok button click
  const datePatternModalOkHandler = () => {
    if (flag) {
      setPattern(modalInput);
      setDatePatternModal(false);
      if (bulkValuesHandler) bulkValuesHandler({PATTERN: modalInput}) // This is being used in Variable Properties
    } 
  };

  // handle Cancel button click
  const datePatternModalCancelHandler = () => {
    setDatePatternModal(false);
  };

  // handle test date pattern
  const testDateHandler = (key, val) => {
    if (!val) {
      setDpNetworkCallMessage(t('BOX_NO_FORMAT_WAS_SPECIFIED__SEL_CANCEL_TO_CLS_DIALOG_AND_RET_TO_MAIN_SCREEN'));
      setValid(false);
    }
    if (val) {
      dispatch(
        api.endpoints.validateDatePattern.initiate({
          datePattern: encodeURIComponent(val),
        })
      ).then((response) => {
        if (response) {
          if (response.data.current_state === 'ERROR') {
            setValid(false)
            setFlag(false)
            setDpNetworkCallMessage(response.data.message)

          } else {
            if (key === 'fromModal') {
              setFlag(true)
              setDpNetworkCallMessage(response.data.message)
            }
            setValid(true)
          }
        }
      })
    }
  };

  const handleInputChange = (e) => {
    setPattern(e.target.value);
  }

  const handleModalInputChange = (e) => {
    setModalInput(e);
  }

  const numberFormatterOkHandler = (valuesObj) => {
    setPattern(valuesObj?.PATTERN || '');
    setPrecision(valuesObj?.PRECISION || '');
    setRoundValue(valuesObj?.ROUND || false);
    setNumberFormatterModal(false);
    if (bulkValuesHandler) bulkValuesHandler({
      PATTERN: valuesObj?.PATTERN || "",
      PRECISION : valuesObj?.PRECISION || "",
      ROUND : valuesObj?.ROUND || ""
    }) // This is being used in Variable Properties
  }

  useEffect(() => {
    if (datePatternModal) setModalInput(pattern);
    setValid(true);
    setDpNetworkCallMessage("");
  }, [datePatternModal]);

  useEffect(() => {
    //TODO: source node change, need to set value of inbound date pattern.
    if (sourceNodeInfo && sourceNodeInfo.FIELDTYPE === "DATE" && ibDatePatternControl) {
      setPattern(sourceNodeInfo.PATTERN || "");
    } 
  }, [sourceNodeInfo])

  const textStyle = dpp ? {minWidth: "180px", height: "34px", maxWidth: "220px"} : {minWidth: "180px", height: "34px"};
  const ctrlDisabled = disabled ? disabled : sourceNodeInfo && sourceNodeInfo.FIELDTYPE && sourceNodeInfo.FIELDTYPE === "DATE" && ibDatePatternControl;

  return (<div className="flex" style={{flex: "1"}}>
    {dpp ? (
      <TextField
        id={inputId}
        size="small"
        variant="outlined"
        label={inputLabel}
        value={(sourceNodeInfo?.FIELDTYPE === "DATE" && ibDatePatternControl) ? (sourceNodeInfo?.PATTERN || "") : pattern}
        onChange={handleInputChange}
        className={"flex-grow-1"}
        style={textStyle}

        disabled={ctrlDisabled}
        // className="flex-grow-1 margin-right-4"
        InputProps={{
          sx: {paddingRight: "8px", height: "34px"},
        }}
      />
    ) : (
      <TextField
        id={inputId}
        size="small"
        variant="outlined"
        label={inputLabel}
        value={(sourceNodeInfo?.FIELDTYPE === "DATE" && ibDatePatternControl) ? (sourceNodeInfo?.PATTERN || "") : pattern}
        onChange={handleInputChange}
        className={"flex-grow-1"}
        style={textStyle}

        disabled={ctrlDisabled}
        // className="flex-grow-1 margin-right-4"
        InputProps={{
          sx: {paddingRight: "8px", height: "34px"},
          endAdornment: !noDateChooser ? (
            <CalendarMonthOutlinedIcon 
              onClick={() => !ctrlDisabled ? setDatePatternModal(true) : null}
              style={{cursor: !ctrlDisabled ? "pointer" : "default"}}
              disabled={ctrlDisabled}
            />
          ) : (
            <MoreHorizIcon 
              onClick={() => !ctrlDisabled ? setNumberFormatterModal(true) : null}
              style={{cursor: !ctrlDisabled ? "pointer" : "default"}}
              disabled={ctrlDisabled}
            />
          )
        }}
      />
    )}
  
    {!noDateChooser ? (
      dpp ? (
        <FormControlLabel
          sx={{marginLeft: "0"}}
          label={t("SIGNED")}
          control={
            <Checkbox
              name="SIGNED"
              size='small'
              checked={signed}
              onChange={(e, checked) => setSigned(checked)}
            />
          } 
        />
      ) : (
        <>
          {/* <Button
            variant="outlined"
            size="small"
            disableElevation
            disabled={disabled ? disabled : sourceNodeInfo && sourceNodeInfo.FIELDTYPE && sourceNodeInfo.FIELDTYPE === "DATE"}
            sx={styles.patternBtn}
            onClick={() => setDatePatternModal(true)}
          >
            <CalendarMonthOutlinedIcon fontSize="small" />
          </Button> */}
          <DatePattern
            openModal={datePatternModal}
            setOpenModal={setDatePatternModal}
            docPath={docPath}
            okHandler={datePatternModalOkHandler}
            cancelHandler={datePatternModalCancelHandler}
            onChangeHandler={handleModalInputChange}
            testDateHandler={testDateHandler}
            dpNetworkCallMessage={dpNetworkCallMessage}
            datePattern={modalInput}
            valid={valid}
          />
        </>
      )
    ) : (
      <>
        {/* TODO: Number Formatter popup WIP */}
        {/* <Button
          disabled={disabled}
          variant="outlined"
          size="small"
          disableElevation
          sx={styles.patternBtn}
          onClick={() => setNumberFormatterModal(true)}
        >
          <MoreHorizIcon fontSize="small" />
        </Button> */}
        <NumberFormatter
          openModal={numberFormatterModal}
          setNumberFormatterModal={setNumberFormatterModal}
          docPath={numFormatterDocPath}
          cancelHandler={setNumberFormatterModal}
          okHandler={numberFormatterOkHandler}
          fieldValue={pattern}
          precision={precision}
          roundInit={roundValue}
        />
      </>
    )}
    
  </div>)
}

const styles = {
  patternBtn: {
    width: "40px",
    padding: "4px 8px",
    minWidth: "40px",
  }
}